<template>

  <v-text-field
      :class="[{'is-read-only' : isReadOnly}, `${ typeInput }-type` ]"
      v-if="!activeTextarea"
      :disabled="isReadOnly"
      :type="typeInputStatic || 'text'"
      :hide-details="rules.length === 0"
      :placeholder="infoInput.placeholder"
      @focus="focusTrue"
      @blur="focusFalse"
      @keyup.enter="keyUpEnter"
      v-model="editableValue"
      @input="onInput"
      :rules="rules"
      variant="solo"
      :max-width="maxWidth"
  >
    <template v-slot:append-inner>
      <icon-default
          class="icon-eye-container"
          @click="changePasswordType"
          v-if="isPassword">
        <IconEye v-if="isActivePassword !== 'password'"/>
        <IconCloseEye v-else/>
      </icon-default>
      <icon-default
          color="light"
          v-if="typeInput === 'search'">
        <IconSearch/>
      </icon-default>
      <icon-default
          class="cross"
          @click="editableValue = ''"
          :size="'small'"
          v-if="typeInput === 'search' && editableValue">
        <IconCross/>
      </icon-default>
    </template>
  </v-text-field>
  <v-textarea
      :class="{ 'is-read-only' : isReadOnly }"
      :disabled="isReadOnly"
      no-resize
      :placeholder="infoInput.placeholder"
      v-model="editableValue"
      @input="onInput"
      variant="solo"
      :rules="rules"
      v-else>
    <template v-slot:append-inner>
      <div class="counter-container">
        <span> {{ counter }}  </span>
        |
        <span> {{ infoInput.maxLength }}  </span>
      </div>
    </template>
  </v-textarea>
</template>

<script>

import IconDefault from "@/components/shared/icons/IconDefault.vue";
import IconSearch from "@/assets/icons/ui/search.svg?inline"
import IconCross from "@/assets/icons/ui/cross.svg?inline"
import IconEye from "@/assets/icons/ui/eye.svg?inline"
import IconCloseEye from "@/assets/icons/ui/eye-close.svg?inline"
import debounce from "debounce";

export default {
  name: "InputMain",
  components: {IconDefault, IconSearch, IconCross, IconEye, IconCloseEye},
  props: {
    clearAfterSubmit: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    },
    activeTextarea: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: null
    },
    infoInput: {
      type: Object,
      default: () => {
        return {
          type: 'text',
          placeholder: 'Search',
          key: 'search',
          change: false,
          maxLength: false
        }
      }
    },
    rules: {
      type: Array,
      default: () => {
        return [

        ]
      }
    }
  },
  data() {
    return {
      isActivePassword: 'password',
      isMounted: false,
      editableValue: '',
      focusParam: false
    }
  },
  computed: {
    isPassword() {
      return this.infoInput?.type === 'password';
    },
    counter() {
      return this.editableValue?.length || 0
    },
    typeInputStatic() {
      return this.isPassword
          ? this.isActivePassword
          : this.infoInput?.type
    },
    typeInput() {
      return this.infoInput?.typeInput || 'default'
    },
    isNumberType() {
      return this.infoInput.type === 'number'
    },
    isChangedValue() {
      return String(this.editableValue) !== String(this.value);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value) {
        this.editableValue = this.value;
      }
    })
  },
  watch: {
    value() {
      this.editableValue = this.value;
    },
    editableValue() {
      if(this.infoInput.maxLength) {
        this.changeMaxLength();
      } else if(this.typeInput === 'search') {
        this.changeValueDebounce();
      } else {
        this.changeValue()
      }
    },
  },
  methods: {
    onInput(e) {
      const value = e.target.value;
      const max = this.infoInput?.maxLength;

      if (max && value.length > max) {
        // отсекаем лишние символы сразу
        this.editableValue = value.slice(0, max);
      } else {
        this.editableValue = value;
      }
    },
    changePasswordType() {
      if(this.isActivePassword === 'password') {
        this.isActivePassword = 'text'
      } else {
        this.isActivePassword = 'password'
      }
    },
    changeMaxLength() {
      this.editableValue = this.editableValue.toString().slice(0, this.infoInput?.maxLength)
      this.changeValue();
    },
    changeValueDebounce: debounce(async function (value, item)  {
      this.changeValue();
    }, 500),
    changeValue() {
      this.$emit('changeValue', {
        value: this.editableValue,
        key: this.infoInput?.key,
        change: this.editableValue !== '' ? this.isChangedValue : false
      })
    },
    keyUpEnter() {
      console.log('asdasdasd')
        this.changeValue();
        this.$emit('submitInfo');
        if(this.clearAfterSubmit) {
          this.editableValue = ''
        }
    }
  }
}
</script>

<style scoped lang="scss">
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;

  &.cross  {
    margin-left: 6px;
    cursor: pointer;
  }
}

.icon-eye-container {
  cursor: pointer;
}

.counter-container {
  color: var(--color-dark-green);
  display: flex;
  font-size: 14px;
  flex-direction: row;
  column-gap: 4px;
}
</style>